export const VEHICLE_FILTER_KEY = 'vehicleNumber';
export const VEHICLE_ONDEMAND_KEY = 'vehicleOnDemand';
export const DVR_ONDEMAND_KEY = 'dvrOnDemand';
export const REDIRECT_PATH = 'redirectToPath';
export const LIBRARY_VIEW_KEY = 'libraryView';